import { cssClass } from '@tableau/vizportalclient-common-components';
import { TabStyles } from '@tableau/widgets';

export const customSqlDialogWidth = 500;
export const customSqlDialogHeight = 500;
const dividerWidth = 468; // custom sql dialog width minus padding
const copyButtonLeftMargin = 371; // dialog width minus padding and copy button length

export const customSqlDialogStyle: React.CSSProperties = {
  paddingTop: TabStyles.Spacing.MediumSpace + 4,
  paddingRight: TabStyles.Spacing.MediumSpace + 4,
  paddingLeft: TabStyles.Spacing.MediumSpace + 4,
  paddingBottom: TabStyles.Spacing.MediumSpace,
};

export const customSqlQueryListClass = cssClass('customSqlQueryList', {
  listStyleType: 'none',
  color: TabStyles.Colors.L8,
  fontSize: TabStyles.Typography.Sizing.Default,
  padding: 0,
  margin: 0,
});

export const customSqlQuerySublistClass = cssClass('customSqlQuerySublist', {
  fontSize: TabStyles.Typography.Sizing.Default,
  padding: 0,
  marginLeft: TabStyles.Spacing.DefaultSpace + 2,
});

export const customSqlQueryTextClass = cssClass('customSqlQueryText', {
  marginTop: TabStyles.Spacing.DefaultSpace,
  marginRight: TabStyles.Spacing.ExtraLargeSpace,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  overflowX: 'auto',
});

export const codeTextClass = cssClass('codeTextClass', {
  fontFamily: 'Courier New',
});

export const customSqlGeneralInlineClass = cssClass('customSqlInline', {
  marginTop: TabStyles.Spacing.LargeSpace,
  marginBottom: TabStyles.Spacing.SmallSpace + 2,
  marginRight: TabStyles.Spacing.ExtraLargeSpace,
  marginLeft: TabStyles.Spacing.ExtraLargeSpace,
});

export const customSqlWorkbookInlineClass = cssClass('customSqlInline', {
  marginTop: 0,
  marginBottom: TabStyles.Spacing.SmallSpace,
  marginRight: TabStyles.Spacing.ExtraLargeSpace,
  marginLeft: TabStyles.Spacing.ExtraLargeSpace,
});

export const customSqlDividerClass = cssClass('customSqlDivider', {
  marginTop: TabStyles.Spacing.MediumSpace + 2,
  marginBottom: TabStyles.Spacing.MediumSpace + 2,
  display: 'inline-block',
  height: 1,
  width: dividerWidth,
  backgroundColor: TabStyles.Colors.L3,
});

export const customSqlCopyButtonStyle: React.CSSProperties = {
  marginLeft: copyButtonLeftMargin,
  marginTop: 50,
};

export const customSqlSingleCopyButtonClass = cssClass('customSqlSingleCopyButton', {
  marginLeft: copyButtonLeftMargin,
});
